<template>
  <div>
    <div class="flex items-center">
      <span class="opacity-45 mr-4">已修改{{page.total}}次</span>
      <el-button size="small" type="text" @click="openEditRecordDialog">查看</el-button>
    </div>
    <!-- 查看修改详情 弹层 -->
    <el-dialog
      class="theme-dialog dialog-center"
      top="0"
      width="70%"
      :modal="false"
      :title="editRecordDialog.title"
      :visible.sync="editRecordDialog.dialogVisible"
      @close="closeEditRecordDialog"
      :destroy-on-close="true"
    >
      <data-table
        ref="edit-record-data-table"
        align="left"
        height="480px"
        :loading="editRecordDialog.loading"
        :data="editRecordDialog.data"
        :columns="editRecordColumns"
        :page.sync="page"
        :showPage="true"
        @size-change="sizeChange"
        @pagination-current-change="currentChange"
      >
        <template #num="{ $index }">
          <div>{{ page.pageSize * (page.currentPage - 1) + ($index + 1) }}</div>
        </template>
        <template #questionDetails="{ row }">
          <stem-col :row="row" :answerContent="answerContent"></stem-col>
        </template>
        <template #editorName="{ row }">
          <div class="w-full whitespace-normal break-all">{{row.editorName}}</div>
        </template>
        <template #editTime="{ row }">
          <div
            class="w-full whitespace-normal break-all"
            v-html="getTime(row.editTime)"
          ></div>
        </template>
        <template #oldAnswerContentItem="{ row }">
          <answer-col
            :row="row"
            :questionType="row.questionDetails.questionType"
            :answerItems="row.oldAnswerContentItem"
            :getAppendItems="getAppendItems"
          ></answer-col>
        </template>
        <template #newAnswerContentItem="{ row }">
          <answer-col
            :row="row"
            :questionType="row.questionDetails.questionType"
            :answerItems="row.newAnswerContentItem"
            :getAppendItems="getAppendItems"
          ></answer-col>
        </template>
      </data-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeEditRecordDialog">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixins from './mixins-recycle'
import AnswerCol from './AnswerCol.vue'
import StemCol from './StemCol'
import { modify, detail } from '@/api/wenjuan/answerList'
import { getAppendItems, getAppendOptions, getRemainder } from './detailMeans.js'
import { convertAnswerText } from '@/question/convert.js'
import DataTable from '@/components/base/DataTable'
import { editRecordColumns } from '@/components/survey-detail/config/columns.js'
import GlobalConfig from '@/global/config'
export default {
  name: 'EditRecord',
  mixins: [mixins],
  components: {
    DataTable,
    AnswerCol,
    StemCol
  },
  props: {
    surveyId: {
      type: [Number, String]
    },
    answerId: {
      type: [Number, String]
    }
  },
  data() {
    return {
      editRecordColumns,
      answerContent: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
        pageSizes: [10, 30, 50, 100]
      },
      editRecordDialog: {
        dialogVisible: false,
        title: '查看修改记录',
        loading: false,
        data: []
      }
    }
  },
  mounted() {
    this.resetEditRecord()
  },
  methods: {
    getTime(time) {
      if (typeof time === 'string') {
        return time.replace(/\s/g, '<br/>')
      }
      return '—'
    },
    convertAnswerText,
    resetEditRecord() {
      this.page.currentPage = 1
      this.page.pageSize = 10
      this.getEditRecord()
    },
    openEditRecordDialog() {
      this.getDetail()
      this.resetEditRecord()
      this.editRecordDialog.dialogVisible = true
    },
    closeEditRecordDialog() {
      this.editRecordDialog.dialogVisible = false
    },
    getDownloadList(list, tag = 'url') {
      let imgList = list.map(item => {
        return this._getDownloadUrl(item[tag])
      })
      return imgList
    },
    getEditRecord() {
      this.editRecordDialog.loading = true
      modify({
        surveyId: GlobalConfig.getSurveyId(),
        answerId: this.answerId,
        size: this.page.pageSize,
        businessType: 0,
        current: this.page.currentPage
      })
        .then(res => {
          if (res.status == 200) {
            let data = res.data?.data || {}
            this.page.total = data.total ?? 0
            this.page.currentPage = data.current ?? 1
            // this.page.pageSize = data.size ?? 10
            this.editRecordDialog.data = (data.records || []).filter(item => {
              return item.businessType == 0
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(e => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.editRecordDialog.loading = false
        })
    },
    // 点击 每页显示条数 触发
    sizeChange(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      // 重新渲染
      this.getEditRecord()
    },
    // 切换页面 （点击页码、数字、输入数字） 触发
    currentChange(val) {
      this.page.currentPage = val
      // 重新渲染
      this.getEditRecord()
    },
    getDetail() {
      detail(this.answerId)
        .then(res => {
          if (res.status == 200) {
            let data = res.data.data
            this.answerContent = data.answerContent
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(e => {
          this.$message.error(e.message)
        })
    },
    getAppendItems,
    getAppendOptions,
    getRemainder
  }
}
</script>
<style lang="scss" scoped>
.record-btn {
  border-radius: 0px;
  // margin-left: 35px;
  position: relative;
}
::v-deep .avue-crud__menu {
  display: none;
}
::v-deep .el-dialog__header {
  padding-bottom: 20px;
  border-bottom: 1px solid #e7e7eb;
}
::v-deep .el-dialog__footer {
  padding-top: 20px;
  border-top: 1px solid #e7e7eb;
}
</style>
